module.exports = __webpack_public_path__ + "img/discord.e662bd87.svg";